__turbopack_context__.v({
  "bookshelfContainer": "BookShelf-module__g7G2FG__bookshelfContainer",
  "promptWrapper": "BookShelf-module__g7G2FG__promptWrapper",
});
